<template>
	<right-panel :datas="applyObj" @onClose="onClose()">
		<div slot="header" v-if="applyObj">
			<div><translate>Start Application</translate></div>
		</div>
		<div slot="content" class="apply-content" v-if="applyObj">
			<el-form ref="applyForm" :model="applyForm" label-width="90px" :rules="applyRules">
				<el-form-item :label="attrText.project">
					<span>{{ applyObj.project }}</span>
				</el-form-item>
				<el-form-item :label="attrText.resourceName">
					<span>{{ applyObj.name }}</span>
				</el-form-item>
				<el-form-item :label="attrText.targetDatabase" prop="database" v-if="applyObj.applyType === 'rds'">
					<el-select v-if="applyObj.db_name && applyObj.db_name[0] !== '*'" v-model="applyForm.database">
						<el-option v-for="(db, index) in applyObj.db_name" :key="index" :label="db" :value="db"></el-option>
					</el-select>
					<el-input v-if="applyObj.db_name && applyObj.db_name[0] === '*'" v-model.trim="applyForm.database"></el-input>
				</el-form-item>
				<!-- <div class="preview-sql">
					<el-button type="text" @click="previewSQL()"><translate>Checking SQL</translate></el-button>
				</div> -->
				<el-form-item label="SQL" prop="sql" v-if="applyObj.applyType === 'rds'">
					<el-input type="textarea" v-model.trim="applyForm.sql" @change="sqlChange()" :autosize="{ minRows: 8, maxRows: 15 }"></el-input>
					<img class="preview-sql-img" @click="previewSQL()" src="../../../../static/images/apply/preview.png" alt="" />
				</el-form-item>
				<el-form-item :label="attrText.comment" prop="comment" v-if="applyObj.applyType === 'rds'">
					<el-input type="textarea" v-model.trim="applyForm.comment" width="360px"></el-input>
				</el-form-item>
				<el-form-item :label="attrText.reason" prop="reason" v-if="applyObj.applyType === 'ecs'">
					<el-input type="textarea" v-model.trim="applyForm.reason"></el-input>
				</el-form-item>
				<el-form-item :label="attrText.validTime" prop="time" v-if="applyObj.applyType === 'ecs'">
					<el-date-picker v-model="applyForm.time" type="datetime" class="safe-datetime-picker" :picker-options="safeOptions" :placeholder="attrText.selectDate"> </el-date-picker>
				</el-form-item>
			</el-form>
			<p v-if="!verifySuccess" style="max-height: 200px; overflow-y: auto; color: red; margin-left: 50px">{{ verifyLog }}</p>
		</div>
		<div slot="footer">
			<el-button v-if="applyObj.applyType === 'rds'" type="primary" :loading="verifyLoading" :disabled="verifyLoading" @click="onVerify()">
				<span v-if="verifyLoading"> </span>
				<span v-else>
					<translate>Verify</translate>
				</span>
			</el-button>
			<el-button type="primary" @click="onSubmit()" :disabled="applyObj.applyType === 'rds' && !verifySuccess">
				<translate>Submit</translate>
			</el-button>
		</div>
	</right-panel>
</template>

<script>
import RightPanel from '../../common/right-panel'
import STORE_CONST from '../../../store/consts'
export default {
	name: 'WorkgroupApply',
	props: {
		items: {
			required: true,
		},
	},
	data() {
		return {
			verifySuccess: false,
			verifyLoading: false,
			verifyLog: '',
			applyObj: {},
			applyForm: {
				sql: '',
				comment: '',
				reason: '',
				time: '',
				database: '',
				btnDisabled: false,
			},
			applyRules: {
				sql: [{ required: true, message: this.$gettext('Please input sql'), trigger: 'blur' }],
				comment: [{ required: true, message: this.$gettext('Please input comment'), trigger: 'blur' }],
				reason: [{ required: true, message: this.$gettext('Please input applicate reason'), trigger: 'blur' }],
				time: [{ required: true, type: 'date', message: this.$gettext('Please select date'), trigger: 'blur' }],
				database: [{ required: true, message: this.$gettext('Please input target database'), trigger: 'blur' }],
			},
			safeOptions: {
				disabledDate(time) {
					return time.getTime() < Date.now()
				},
			},
		}
	},
	computed: {
		attrText() {
			return this.initAttrText()
		},
	},
	methods: {
		onClose() {
			this.applyObj = null
			this.$emit('onClosePanel')
			this.resetFrom()
		},
		resetFrom() {
			if (this.$refs['applyForm'] !== undefined) {
				this.$refs['applyForm'].resetFields()
			}
		},
		sqlChange() {
			this.verifySuccess = false
			this.verifyLog = ''
		},
		onVerify() {
			if (this.applyObj.applyType === 'ecs') return

			this.verifyLoading = true
			const params = {
				sql: this.applyForm.sql,
				type: this.items.type,
			}
			this.$store.dispatch(STORE_CONST.WORKGROUP.VERIFY_SQL, params).then((res) => {
				console.log(res, 'res')
				if (res.success) {
					this.verifySuccess = true
					this.$notify({
						message: this.$gettext('Check success!'),
						type: 'success',
					})
				} else {
					this.verifySuccess = false
					this.verifyLog = res.message
					this.$notify({
						message: this.$gettext('Check failed!'),
						type: 'error',
					})
				}
				this.verifyLoading = false
			})
		},
		onSubmit() {
			this.$refs['applyForm'].validate((valid) => {
				if (valid) {
					let params
					console.log(this.applyObj.applyType, 'this.applyObj.applyType')
					if (this.applyObj.applyType === 'ecs') {
						params = {
							project_id: +this.$route.params.id,
							project_resource_id: this.applyObj.project_resource_id,
							reason: this.applyForm.reason,
							expire_time: Date.parse(this.applyForm.time) / 1000,
						}
						this.$store.dispatch(STORE_CONST.REVIEW.CREATE_SAFE_APPLY, params).then(
							(res) => {
								this.applyForm.btnDisabled = true
								this.$notify({
									type: 'success',
									message: this.$gettext('Create successfully!'),
								})
								this.onClose()
							},
							() => {
								this.applyForm.btnDisabled = false
							}
						)
					} else {
						params = {
							project_resource_id: this.applyObj.project_resource_id,
							sql: this.applyForm.sql,
							database: this.applyForm.database,
							comment: this.applyForm.comment,
						}
						this.$store.dispatch(STORE_CONST.REVIEW.CREATE_SQL_APPLICATION, params).then(
							(res) => {
								this.applyForm.btnDisabled = true
								this.$notify({
									type: 'success',
									message: this.$gettext('Create successfully!'),
								})
								this.onClose()
							},
							() => {
								this.applyForm.btnDisabled = false
							}
						)
					}
					console.log('params', params)
				}
			})
		},
		initAttrText() {
			return {
				sql: this.$gettext('SQL Application'),
				safeMode: this.$gettext('Security Mode'),
				project: this.$gettext('Workgroup'),
				resource: this.$gettext('Resource'),
				comment: this.$gettext('Comment'),
				resourceName: this.$gettext('Resource Name'),
				reason: this.$gettext('The Reasons For The Application'),
				validTime: this.$gettext('Valid Time'),
				startApplication: this.$gettext('Start Application'),
				select: this.$gettext('select'),
				myApplication: this.$gettext('My Application'),
				general: this.$gettext('General'),
				createTime: this.$gettext('Created Time'),
				applyer: this.$gettext('Applyer'),
				pendingApplication: this.$gettext('Pending Application'),
				myApproved: this.$gettext('My Approved'),
				status: this.$gettext('Status'),
				updateTime: this.$gettext('Update Time'),
				selectDate: this.$gettext('Please Select Date'),
				effectiveTime: this.$gettext('Valid Time'),
				targetDatabase: this.$gettext('Target Database'),
			}
		},
		previewSQL() {
			this.$emit('onShowModal', { name: 'previewSQL', data: this.applyForm })
		},
	},
	components: {
		RightPanel,
	},
	watch: {
		items: {
			handler: function (newVal) {
				if (this.applyObj) {
					this.applyObj = {}
					setTimeout(() => {
						console.log('items', this.items)
						this.applyObj = this.items
						this.applyForm.database = this.items.db_name[0] === '*' ? '' : this.items.db_name[0]
						this.applyForm.sql = this.items.sql
						this.isHideFooter = this.items.isHideFooter
					}, 300)
				} else {
					console.log('items', this.items)
					this.applyObj = this.items
					this.applyForm.database = this.items.db_name[0] === '*' ? '' : this.items.db_name[0]
					this.applyForm.sql = this.items.sql
					this.isHideFooter = this.items.isHideFooter
				}
			},
			deep: true,
		},
	},
}
</script>

<style lang="scss">
.apply-content {
	padding: 10px;
	.safe-datetime-picker {
		width: 100%;
	}
	.preview-sql-img {
		width: 17px;
		position: absolute;
		top: 10px;
		right: 25px;
		cursor: pointer;
	}
}
</style>



// WEBPACK FOOTER //
// workgroup-apply.vue?88ff7620